import React from 'react';

import { useFeatureFlags } from 'src/context/flagsContext';

import { Loader } from '../Loading';

import LegacyTable, { TableProps } from './Table';

export * from './HeaderRender';
export * from './Renderer';
export * from './TableResultCount';
export * from './Table';

// TODO: AG Grid v27→v35 migration — remove this lazy import and the
// flag-gated branch below once the v35 rollout is complete (Phase 5 of
// the migration). Lazy so v35 modules + CSS only load when
// EnableAgGridUpgrade is on, preventing v35 styles from leaking into
// the legacy grid. The v35 Table accepts the same TableProps shape as the
// legacy component so callers don't need to migrate their ColDefs during the
// rollout; the v35 component normalizes legacy fields (e.g.
// cellRendererFramework) at runtime. The `unknown` re-type below is the
// migration-shim type bridge — v27 and v35 ColDef signatures genuinely
// differ (v27's ValueGetterParams.columnApi was merged into v35's GridApi)
// so there is no single overlapping type that satisfies both. This is the
// only cast in the rollout path; it disappears when the legacy code is
// removed at Phase 5.
const NewTable = React.lazy(
  () =>
    import(/* webpackChunkName: "ag-grid-v35" */ 'src/components/AgGrid/Table'),
) as unknown as React.ComponentType<TableProps>;

const Table: React.FC<TableProps> = (props) => {
  const { EnableAgGridUpgrade } = useFeatureFlags();

  if (EnableAgGridUpgrade) {
    return (
      <React.Suspense fallback={<Loader />}>
        <NewTable {...props} />
      </React.Suspense>
    );
  }

  return <LegacyTable {...props} />;
};

export default Table;
